<section *ngIf="display">
  <p-card class="cinch-accordion">
    <p-accordion [value]="initialStateOpen">
      <p-accordion-panel [value]="0">

        <p-accordion-header>{{title}}</p-accordion-header>

        <p-accordion-content>
          <ng-content></ng-content>
        </p-accordion-content>

      </p-accordion-panel>
    </p-accordion>
  </p-card>
</section>
